"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.advanced-reports.disabled': 'La funzione report avanzati non è disponibile nel tuo piano attuale.',
};
